<template>
    <div class="join-builder d-flex flex-column justify-content-start gap-3 dataset-accordion" :id="'dataset-join-accordion-'+local_dataset.id" >
        <div class="card accordion mb-0" v-for="(join_dataset, join_dataset_index) in local_dataset.joins" :key="'dataset-join-builder-'+join_dataset.id" >
            <div class="accordion-item" v-if="join_dataset && join_dataset.id != null">
                <div class="accordion-header">
                    <button class="accordion-button py-0 collapsed" type="button" @click="open_accordion = join_dataset.id"
                        :data-bs-target="'#dataset-join-builder-'+join_dataset.id" data-bs-toggle="collapse"
                        aria-expanded="false" :aria-controls="'dataset-join-builder-'+join_dataset.id">
                        <div class="row w-100">
                            <div class="col-10 d-flex align-items-center">
                                <h6 class="mb-0">{{join_dataset.id < 0 && join_dataset.name =='' ? 'New Join Details' : join_dataset.name}}</h6>
                            </div>
                            <div class="col-2">
                                <div class="d-flex float-end">
                                    <button class="btn btn-none btn-icon-only-sm" :disabled="!if_allow_edit">
                                        <img class="icon" src="/img/icons/avid-icons/trash.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete" @click.prevent="deleteJoinData(join_dataset_index)" :disabled="!if_allow_edit" alt=""> 
                                    </button>
                                </div>
                            </div>
                        </div> 
                    </button>                                        
                </div>
                <div class="accordion-body accordion-collapse collapse mt-3" :id="'dataset-join-builder-'+join_dataset.id" 
                    :data-bs-parent="'#dataset-join-accordion-'+local_dataset.id" :class="open_accordion == join_dataset.id ? 'show' : ''">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <label class="form-label">Data Set to Merge</label>
                            <accordion-select v-model="join_dataset.joined_data_set" :options="available_datasets" 
                                :key="'join-dataset-'+join_dataset.id" :if_allow_edit="if_allow_edit"
                                @update:modelValue="changeDatasetToJoin(join_dataset_index)"  
                                :class="((errors[join_dataset_index].joined_data_set != '' )? 'is-invalid':'')"></accordion-select>
                            
                            <div class="text-danger invalid-feedback" v-if="errors[join_dataset_index].joined_data_set != ''">
                                {{errors[join_dataset_index].joined_data_set}}
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <label class="form-label">Display Name for Field Grouping</label>
                            <input type="text" class="form-control" v-model="join_dataset.name" 
                                :class="((errors[join_dataset_index].name != '' )? 'is-invalid':'')" :disabled="!if_allow_edit" aria-label="Display Name for Field Grouping">
                            <div class="text-danger invalid-feedback" v-if="errors[join_dataset_index].name != ''">
                                {{errors[join_dataset_index].name}}
                            </div>
                        </div>

                        <div class="col-12 mt-3">
                            <label class="form-label">Join Method: </label>
                            <div class="row">
                                <div class="col-12 col-md-4">   
                                    <button class="btn btn-secondary me-3 mb-2 mb-md-0 d-flex" @click="changeJoinType(join_dataset_index, 'inner_join')" :disabled="!if_allow_edit">
                                        <input class="form-radio-input mt-1 me-2" type="radio" :checked="join_dataset.join_type == 'inner_join'" aria-label="Radio option">Matching Records Only
                                        <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" data-placement="top" title="In SQL, this is the equivalent of an INNER JOIN." alt=""></img>                                                                             
                                    </button>                                    
                                </div>
                                <div class="col-12 col-md-4">  
                                    <button class="btn btn-secondary me-3 mb-2 mb-md-0 d-flex" @click="changeJoinType(join_dataset_index, 'left_join')" :disabled="!if_allow_edit">
                                        <input class="form-radio-input mt-1 me-2" type="radio" :checked="join_dataset.join_type == 'left_join'" aria-label="Radio option">Match Where Possible  
                                        <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" data-placement="top" title="In SQL, this is the equivalent of a LEFT JOIN." alt=""></img>                                                                       
                                    </button>
                                </div>
                                <div class="col-12 col-md-4">  
                                    <button class="btn btn-secondary me-3 mb-2 mb-md-0 d-flex" @click="changeJoinType(join_dataset_index, 'full_outer_join')" :disabled="!if_allow_edit">
                                        <input class="form-radio-input mt-1 me-2" type="radio" :checked="join_dataset.join_type == 'full_outer_join'" aria-label="Radio option">All Records Regardless of Match
                                        <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" data-placement="top" title="In SQL, this is the equivalent of a FULL JOIN." alt=""></img>                                                                         
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3">
                        <p>Join keys:</p>
                        <table class="column-mapping-table mapping-table mt-2">
                            <thead class="w-100">
                                <tr>
                                    <th>
                                        <div class="flex-column">
                                            <p class="ms-2">Column from Merged Data Set </p>
                                        </div>
                                    </th>
                                    <th>
                                        <!-- <div>
                                            <small>Maps to</small>
                                        </div> -->
                                    </th>
                                    <th>
                                        <div class="flex-column">
                                            <p class="ms-2">Column from This Data Set </p>
                                        </div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class="w-100 p-2">
                                <tr v-for="(join_key, join_key_index) in join_dataset.join_on" :key="join_key.id">
                                    <td class="mapping-grid__source pt-2">
                                        <div class="mb-2" :class="{'input-group': join_dataset.joined_data_set && join_key.source_column.column == 'CUSTOM' }">
                                            <input type="text" class="form-control" v-if="!join_dataset.joined_data_set" disabled aria-label="Text input">
                                            <accordion-select-with-list-header v-else v-model="join_key.source_column.column" :list_header_text="'Custom Logic'"
                                                :options="join_dataset.joined_data_set.columns" :key="'source-column-'+join_key.id" 
                                                @update:modelValue="changeSourceColumn(join_key_index, join_dataset.joined_data_set.columns)"
                                                @listHeaderAction="selectCustomLogic(join_dataset_index, join_key_index, join_key)" 
                                                :class="{'is-invalid' : errors[join_dataset_index].join_on[join_key_index].source_column != ''}"
                                                :if_allow_edit="if_allow_edit">
                                            </accordion-select-with-list-header>

                                            <button class="btn btn-secondary" v-if="join_key.source_column.column == 'CUSTOM' && !join_key.source_column.editing" 
                                                data-bs-toggle="tooltip" title="Edit the Custom Logic" @click="editing(join_dataset_index, join_key)" :disabled="!if_allow_edit">
                                                <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                            </button>
                                            <button class="btn btn-secondary" v-if="join_key.source_column.column == 'CUSTOM' && join_key.source_column.editing" 
                                                data-bs-toggle="tooltip" title="Close the Custom Logic Editor" @click.prevent="stopEditing(join_key)" :disabled="!if_allow_edit">
                                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                                            </button>
                                        </div>
                                        <div class="text-danger invalid-feedback" v-if="errors[join_dataset_index].join_on[join_key_index].source_column != ''">
                                            {{errors[join_dataset_index].join_on[join_key_index].source_column}}
                                        </div>
                                    </td>

                                    <td class="mapping-grid_map_to pt-2">
                                        <div class="d-flex align-items-center">
                                            <small>Maps to</small>
                                        </div>
                                    </td>

                                    <td class="mapping-grid__destination pt-2">
                                        <div class="d-flex mb-2">
                                            <input type="text" class="form-control" v-if="!join_dataset.joined_data_set" disabled aria-label="Column">
                                            <accordion-select v-else v-model="join_key.dest_column.column" :options="local_dataset.source_columns_array"
                                                :class="{'is-invalid' : errors[join_dataset_index].join_on[join_key_index].dest_column != ''}"
                                                :if_allow_edit="if_allow_edit"
                                                @update:modelValue="changeDestinationColumn(join_key_index, $event)">
                                            </accordion-select>
                                        </div>
                                        <div class="text-danger invalid-feedback" v-if="errors[join_dataset_index].join_on[join_key_index].dest_column != ''">
                                            {{errors[join_dataset_index].join_on[join_key_index].dest_column}}
                                        </div>
                                    </td>

                                    <td class="mapping-grid__action pt-2">
                                        <div data-bs-toggle="tooltip" title="Must have at least one Join Key.">
                                            <button v-if="join_dataset.join_on.length == 1" class="mapping-grid__button btn btn-none p-0" disabled>
                                                <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                                <div class="strike-line"></div>
                                            </button>
                                        </div>                                       
                                        <div>
                                            <button v-if="join_dataset.join_on.length > 1" :disabled="!if_allow_edit" 
                                                class="mapping-grid__button btn btn-none p-0" @click="deleteJoinDataKey(join_dataset_index, join_key_index);">
                                                <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                            </button>
                                        </div>
                                    </td>

                                    <transition name="slide">
                                        <tr class="custom-logic mb-4" v-if="join_key.source_column.column == 'CUSTOM' && 
                                            (join_key.source_column.editing || errors[join_dataset_index].join_on[join_key_index].source_column.indexOf('logic') > -1)">
                                            <td :colspan="4" class="simplified-query-builder-wrapper mx-3 p-0">      
                                                <h4 class="mx-2 mb-2 mt-3"><i class="fas fa-sliders me-2"></i>Custom Logic</h4>
                                                <div class="accordion" :id="'accordion-' + join_key.id" ref="accordion">
                                                    <draggable handle=".handle" :list="join_key.source_column.column_logic.units" :element="'div'" :tag="'span'" @end="onDragEnd" item-key="id" :disabled="!if_allow_edit">
                                                        <template #item="{element: unit, index: j}">
                                                            <div class="accordion-item border-bottom-0">
                                                                <h1 class="accordion-header position-relative" :id="'heading-'+join_key.id+'-'+j">
                                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-'+join_key.id+'-'+j" :aria-expanded="(j==0 && errors[join_dataset_index].join_on[join_key_index].source_column.indexOf('logic') == -1)?true:false"
                                                                    :class="{'collapsed' : (j > 0 || errors[join_dataset_index].join_on[join_key_index].source_column.indexOf('logic') > -1)}">
                                                                        Output:
                                                                        <em class="ms-1" v-if="join_key.source_column.column_logic.default_value === true || join_key.source_column.column_logic.default_value === false">
                                                                            {{ (join_key.source_column.column_logic.default_value === true) ? "Yes": "No" }}
                                                                        </em>
                                                                        <em class="ms-1" v-else>
                                                                            <span v-html="(unit.value_type == 'static' && unit.value != '') ? '&ldquo;' : ''"></span>
                                                                            {{ (unit.value == '') ? "(Not Set)" : getPrettyColName(unit.value) }}
                                                                            <span v-html="(unit.value_type == 'static' && unit.value != '') ? '&rdquo;' : ''"></span>
                                                                        </em>
                                                                        <a class="btn btn-none p-2 action" style="right: 48px;" 
                                                                            @click.stop="addLogicUnit($event, join_key, j)" 
                                                                            data-bs-toggle="tooltip" data-placement="top" 
                                                                            title="Add Logic Unit" :disabled="!if_allow_edit">
                                                                            <i class="fas fa-plus"></i>
                                                                        </a>
                                                                        <a class="btn btn-none p-2 action" style="right: 84px;" 
                                                                            @click.stop="removeLogicUnit($event, join_key, j)" 
                                                                            data-bs-toggle="tooltip" data-placement="top" title="Delete" 
                                                                            :disabled="!if_allow_edit">
                                                                            <i class="fa fa-trash"></i>
                                                                        </a>
                                                                        <a class="btn btn-none p-2 action handle" style="right: 118px; cursor: move;" 
                                                                            data-bs-toggle="tooltip" data-placement="top" title="Move to Adjust Priority" 
                                                                            v-if="join_key.source_column.column_logic.units.length > 1" 
                                                                            :disabled="!if_allow_edit">
                                                                            <i class="fa fa-up-down-left-right"></i>
                                                                        </a>
                                                                    </button>
                                                                </h1>
                                                                <div :id="'collapse-'+join_key.id+'-'+j" class="accordion-collapse collapse" :class="{'show' : (j==0 && errors[join_dataset_index].join_on[join_key_index].source_column.indexOf('logic') == -1) }" :data-bs-parent="'#accordion-' + join_key.id">
                                                                    <div class="accordion-body pt-0">
                                                                        <div class="row mb-3">
                                                                            <div class="col">
                                                                                <query-builder-simplified 
                                                                                    :client="client" 
                                                                                    v-model="unit.logic"
                                                                                    :static_db_columns="join_dataset.joined_data_set.columns" 
                                                                                    :is_white="false" 
                                                                                    ref="queryBuilder"
                                                                                    :source="join_dataset.joined_data_set.data_source" 
                                                                                    :data_source_id="join_dataset.joined_data_set.id"
                                                                                    :key="'query-builder-'+unit.id"
                                                                                    :if_allow_edit="if_allow_edit">
                                                                                </query-builder-simplified>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex flex-row align-items-center mt-3">
                                                                            <div class="col-md-4 col-12">Then, output value will be: </div>
                                                                            <div class="col-md-8 col-12">
                                                                                <div class="input-group">
                                                                                    <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="!if_allow_edit">{{ getValueTypeDisplay(unit.value_type) }}</button>
                                                                                    <ul class="dropdown-menu dropdown-menu-primary dropdown-menu-start">
                                                                                        <li><a class="dropdown-item" @click.prevent="unit.value_type='column'" :disabled="!if_allow_edit">Column Value</a></li>
                                                                                        <li><a class="dropdown-item" @click.prevent="unit.value_type='sql'" :disabled="!if_allow_edit">SQL Value</a></li>
                                                                                        <li><a class="dropdown-item" @click.prevent="unit.value_type='static'" :disabled="!if_allow_edit">Static Value</a></li>
                                                                                    </ul>
                                                                                    <select v-if="join_key.source_column.column_logic.default_value === true || join_key.source_column.column_logic.default_value === false" class="form-control" placeholder="Value"
                                                                                        v-model="unit.value" :id="'unit-text-'+unit.id" @change="errors[join_dataset_index].join_on[join_key_index].source_column=''" :disabled="!if_allow_edit" aria-label="Value">
                                                                                        <option :value="true">Yes</option>
                                                                                        <option :value="false">No</option>
                                                                                    </select>
                                                                                    <input v-else-if="unit.value_type=='sql' || unit.value_type=='static'" type="text"
                                                                                        class="form-control" placeholder="Value" @change="sanitizeSQLStatement(join_dataset_index, join_key_index, j, unit)" :class="{'is-invalid' : errors[join_dataset_index].join_on[join_key_index].source_column != null && errors[join_dataset_index].join_on[join_key_index].source_column != ''}"
                                                                                        v-model="unit.value" :id="'unit-text-'+unit.id" :disabled="!if_allow_edit" aria-label="Text input">
                                                                                    <accordion-select v-else-if="unit.value_type == 'column'" v-model="unit.value" :options="join_dataset.joined_data_set.columns.slice(1)" @update:modelValue="errors[join_dataset_index].join_on[join_key_index].source_column = ''"
                                                                                    :class="{'is-invalid' : errors[join_dataset_index].join_on[join_key_index].source_column != null && errors[join_dataset_index].join_on[join_key_index].source_column != ''}" :if_allow_edit="if_allow_edit"></accordion-select>
                                                                                </div>
                                                                                <div class="text-danger invalid-feedback" v-if="errors[join_dataset_index].join_on[join_key_index].source_column != null && errors[join_dataset_index].join_on[join_key_index].source_column != ''">
                                                                                    {{errors[join_dataset_index].join_on[join_key_index].source_column}}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </draggable>
                                                    <div class="accordion-item" style="border-top-left-radius: 0; border-top-right-radius: 0;">
                                                        <h1 class="accordion-header" :id="'default-'+join_key.id">
                                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-'+join_key.id+'-default'" aria-expanded="false" style="border-top-left-radius: 0; border-top-right-radius: 0;">
                                                                Default Output:
                                                                <em class="ms-1" v-if="join_key.source_column.column_logic.default_value === true || join_key.source_column.column_logic.default_value === false">
                                                                    {{ (join_key.source_column.column_logic.default_value === true) ? "Yes": "No" }}
                                                                </em>
                                                                <em class="ms-1" v-else-if="join_key.source_column.column_logic.default_type=='column'">
                                                                    {{ (join_key.source_column.column_logic.default_value == '') ? "(Not Set)" : propercase(join_key.source_column.column_logic.default_value) }}
                                                                </em>
                                                                <em class="ms-1" v-else>
                                                                    <span v-html="(join_key.source_column.column_logic.default_type == 'static'  && join_key.source_column.column_logic.default_value != '') ? '&ldquo;' : ''"></span>
                                                                    {{ (join_key.source_column.column_logic.default_value == '') ? "(Not Set)" : join_key.source_column.column_logic.default_value }}
                                                                    <span v-html="(join_key.source_column.column_logic.default_type == 'static' && join_key.source_column.column_logic.default_value != '') ? '&rdquo;' : ''"></span>
                                                                </em>
                                                                <a class="btn btn-none p-2 action" style="right: 48px;" 
                                                                    @click.stop="addLogicUnit($event, join_key, join_key.source_column.column_logic.units.length)" 
                                                                    data-bs-toggle="tooltip" data-placement="top" title="Add Logic Unit" :disabled="!if_allow_edit">
                                                                    <i class="fas fa-plus"></i>
                                                                </a>
                                                            </button>
                                                        </h1>
                                                        <div :id="'collapse-'+join_key.id+'-default'" class="accordion-collapse collapse" :data-bs-parent="'#accordion-'+ join_key.id">
                                                            <div class="accordion-body pt-0">
                                                                <div class="flex-row d-flex">
                                                                    <span class="col-md-6 col-12">When none of cases above are met, output value will be: </span>
                                                                    <div class="col-md-6 col-12">
                                                                        <div class="input-group">
                                                                            <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="!if_allow_edit">
                                                                                {{ getValueTypeDisplay(join_key.source_column.column_logic.default_type)}}
                                                                            </button>
                                                                            <ul class="dropdown-menu dropdown-menu-primary dropdown-menu-start">
                                                                                <li><a class="dropdown-item" @click.prevent="join_key.source_column.column_logic.default_type='column'">Column Value</a></li>
                                                                                <li><a class="dropdown-item" @click.prevent="join_key.source_column.column_logic.default_type='sql'">SQL Value</a></li>
                                                                                <li><a class="dropdown-item" @click.prevent="join_key.source_column.column_logic.default_type='static'">Static Value</a></li>
                                                                            </ul>
                                                                            <select v-if="join_key.source_column.data_type == 'boolean' && join_key.source_column.column_logic.default_type == 'static'" class="form-control" placeholder="Value"
                                                                                v-model="join_key.source_column.column_logic.default_value" :id="'unit-text--default-'+join_key.id"  @change="join_key.source_column.column_logic.default_value_error=''" :disabled="!if_allow_edit" aria-label="Value">
                                                                                <option :value="true">Yes</option>
                                                                                <option :value="false">No</option>
                                                                            </select>


                                                                            <input v-else-if="join_key.source_column.column_logic.default_type != 'column'" type="text"
                                                                                class="form-control" placeholder="Value"
                                                                                v-model="join_key.source_column.column_logic.default_value" id='unit-text-default' :disabled="!if_allow_edit" aria-label="Text input">

                                                                            <accordion-select v-else v-model="join_key.source_column.column_logic.default_value" 
                                                                            :options="join_dataset.joined_data_set.columns.slice(1)" :if_allow_edit="if_allow_edit"></accordion-select>
                                                                            
                                                                            <button v-if="join_key.source_column.column_logic.default_type=='sql'" class="btn btn-secondary dropdown-toggle" 
                                                                            type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="!if_allow_edit">Columns</button>
                                                                            <ul v-if="join_key.source_column.column_logic.default_type=='sql'" class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                                                                <li><a class="dropdown-item" v-for="(col_name, key) in src_columns" @click="addColumnToText('default', key)">{{col_name}}</a></li>
                                                                            </ul>
                                                                        </div>
                                                                        <div class="text-danger invalid-feedback" v-if="join_key.source_column.column_logic.default_value_error != ''">
                                                                            {{join_key.source_column.column_logic.default_value_error }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>   
                                            </td>
                                        </tr>
                                    </transition> 
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mt-3 alert alert-danger p-3 d-flex align-items-center" v-if="join_dataset.message && join_dataset.message != ''">
                        <img src="/img/icons/avid-icons/info-circle.svg" class="icon flex-shrink-0 me-3 " alt="">
                        <div v-html="join_dataset.message"></div>
                    </div>
                    <button v-if="if_allow_edit" class="btn btn-secondary mt-2" @click.prevent="addNewJoinKey(join_dataset_index)" :disabled="!join_dataset.joined_data_set">
                        <i class="fa fa-plus"></i> Add Key
                    </button>        
                    <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                        <button class="btn btn-secondary mt-2" :disabled="true">
                            <i class="fa fa-plus"></i> Add Key
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <button v-if="if_allow_edit" class="btn btn-secondary mt-2" @click.prevent="addNewJoinData()">
            <i class="fa fa-plus"></i> Join Additional Data Set
        </button>
        <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
            <button class="btn btn-secondary mt-2" :disabled="true">
                <i class="fa fa-plus"></i> Join Additional Data Set
            </button>
        </div>
    </div>
</template>

<script>
import { Tooltip } from 'bootstrap';
import { defineComponent } from 'vue';
import draggable from 'vuedraggable';

export default defineComponent({
    components: { draggable },
    props: {
        client: {
            type: Object,
            required: true
        },
        dataset: {
            type: Object,
            required: true
        },
        all_datasets: {
            type: Array,
            required: true
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        if_allow_edit: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            local_dataset: {
                ...this.dataset,
                joins: this.modelValue ? [...this.modelValue] : [],
            },
            available_datasets: [],
            errors: [],
            open_accordion: -1,
            outside_update: false,
            join_dataset: {},
            validateSettingsDebounceTimer: null
        };
    },
    beforeMount() {
        this.setupUI();
    },
    mounted() {
        this.initTooltips();
    },
    updated() {
        this.initTooltips();
    },
    beforeUnmount() {
        // Clear the debounce timer to prevent memory leaks
        if (this.validateSettingsDebounceTimer) {
            clearTimeout(this.validateSettingsDebounceTimer);
        }
    },
    computed: {
        src_columns_sorted() {
            var keys = Object.keys(this.local_dataset.source_columns);
            keys.sort();
            var obj = {};
            for(var i in keys) {
                //Split the this.src_columns[keys[i]] string based upon . and then rejoin with a :
                let col_name = this.local_dataset.source_columns[keys[i]];
                if(keys[i].indexOf(".") != -1) {
                    var split = keys[i].split(".", 2);
                    col_name = this.propercase(split[0].trim()) + ": " + this.propercase(split[1].trim());
                }
                obj[keys[i]] = col_name;
            }
            return obj;
        }
    },
    watch: {
        dataset() {
            //Dataset updated from outside
            this.outside_update = true;
            this.setupUI();
            this.$forceUpdate();
        },
        modelValue: {
            handler(newVal) {
                if (!this.outside_update) {
                    this.local_dataset.joins = newVal ? [...newVal] : [];
                }
                this.outside_update = false;
            },
            deep: true,
            immediate: true,
        },
        'local_dataset.joins': {
            handler(newVal) {
                // Only emit if the value has actually changed and we're not in the middle of an outside update
                if (!this.outside_update && JSON.stringify(newVal) !== JSON.stringify(this.modelValue)) {
                    this.$emit('update:modelValue', newVal);
                }
            },
            deep: true,
        },
    },
    methods: {
        changeSourceColumn(index, columns){
            // Find the index of the join in the array instead of using find()
            let joinIndex = this.local_dataset.joins.findIndex(element => element.id === this.open_accordion);
            if (joinIndex === -1) return;
            
            let source_column = this.local_dataset.joins[joinIndex].join_on[index].source_column;
            if(source_column.column == 'CUSTOM') {
                source_column.data_type = 'string';
            } else {
                let column = columns.find(column => column.value == source_column.column);
                if(column) {
                    source_column.data_type = column.data_type;
                }
            }
            
            // Update the source column directly in the array
            this.local_dataset.joins[joinIndex].join_on[index].source_column = source_column;
            
            // Validate settings if destination column is not empty
            if (this.local_dataset.joins[joinIndex].join_on[index].dest_column.column) {
                this.debouncedValidateSettings();
            }
        },
        changeDestinationColumn(index, columnValue) {
            // Find the index of the join in the array instead of using find()
            let joinIndex = this.local_dataset.joins.findIndex(element => element.id === this.open_accordion);
            if (joinIndex === -1) return;
            
            // Update the destination column directly in the array
            this.local_dataset.joins[joinIndex].join_on[index].dest_column.column = columnValue;
            
            // Validate settings if source column is not empty
            if (this.local_dataset.joins[joinIndex].join_on[index].source_column.column) {
                this.debouncedValidateSettings();
            }
        },
        setupUI() {
            this.errors = [];
            this.local_dataset = {
                ...this.dataset,
                joins: this.modelValue ? [...this.modelValue] : [],
            };
            this.local_dataset.source_columns_array = this.getSourceColumnArray(this.local_dataset.source_columns);
            
            this.getAvailableDatasetsToJoin();
            if (!this.local_dataset.joins || this.local_dataset.joins.length == 0) {
                this.local_dataset.joins = [];
                this.addNewJoinData();
            }
            else {
                // Always keep the errors array in sync with the joins array
                this.local_dataset.joins.forEach((join) => {
                    // Create a corresponding error object for every join
                    this.addEmptyError();

                    // Ensure each join key has a matching error object
                    for (let j = 1; j < join.join_on.length; j++) {
                        this.errors[this.errors.length - 1].join_on.push(this.getEmptyJoinError());
                    }

                    // If a joined data-set is already picked, hydrate its column list
                    if (join.joined_data_set != null) {
                        const dataset_selected = this.all_datasets.find(
                            (dataset) => dataset.id.toString() == join.joined_data_set_id
                        );
                        if (dataset_selected) {
                            join.joined_data_set.columns = this.getColumnsFromJoinedDataSet(dataset_selected);
                        }
                    }
                });

                // Guarantee there is at least one blank join to work with
                if (this.local_dataset.joins.length === 0) {
                    this.addNewJoinData();
                }
            }
        },             
        getSourceColumnArray(arr) {
            var columns = [];
            //Sort the this.src_columns
            var keys = arr ? Object.keys(arr) : [];
            //sort keys but, if it has a period in the name, it should be lower than works without a period
            keys.sort(function(a, b) {
                if(a.indexOf(".") == -1 && b.indexOf(".") != -1)
                    return -1;
                else if(a.indexOf(".") != -1 && b.indexOf(".") == -1)
                    return 1;
                else
                    return a.localeCompare(b);
            });
            
            for(var i in keys) {
                let key = keys[i];
                let text = arr[key];
                let category = null;

                //If the key contains a .
                if(key.indexOf(".") != -1) {
                    //split string by . , separate any structs that are 3+ layers deep with a > in between
                    var split = key.split(".");
                    category = this.propercase(split[0]);
                    text = this.propercase(split.slice(1).join(' > '));
                }

                columns.push({
                    value: key,
                    text: text,
                    category: category
                });
            }

            return columns;
        },
        initTooltips() {
            // Use template refs instead of this.$el
            const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipElements.forEach((tooltipTriggerEl) => {
                // Avoid initializing the same tooltip multiple times
                if (!tooltipTriggerEl._tooltipInstance) {
                    tooltipTriggerEl._tooltipInstance = new Tooltip(tooltipTriggerEl);
                }
            });
        },
        getStaticColumns(columns) {
            // Return an array with the key being the display_name column and the value being generateColumnName function
            let arr = [];
            //Skip the first column as it is the custom logic
            let i = 0;
            columns.forEach((column) => {
                if(i++ > 0)
                    arr[column.value] =  column.display_name;
            });
            return arr;
        },
        debouncedValidateSettings() {
            // Clear existing timer
            if (this.validateSettingsDebounceTimer) {
                clearTimeout(this.validateSettingsDebounceTimer);
            }
            
            // Set new timer for 500ms delay
            this.validateSettingsDebounceTimer = setTimeout(() => {
                this.validateSettings();
            }, 500);
        },
        validateSettings() {
            //If the dataset was updated within the view, there are joins, and it is valid (without showing the error messages)
            if(!this.outside_update && this.local_dataset.joins && this.local_dataset.joins.length > 0 && 
                this.isValid(false) && this.open_accordion != -1) {
                //Find the right join that is being edited
                let joinIndex = this.local_dataset.joins.findIndex(element => element.id === this.open_accordion);
                if (joinIndex === -1) return;
                
                let join = {...this.local_dataset.joins[joinIndex]};

                join.join_on.forEach(join_on => {
                    if (typeof join_on.dest_column.column == 'object') {
                        join_on.dest_column.column = join_on.dest_column.column.value;
                    }
                });

                // All validations passed, proceed to POST
                window.axios
                    .post('/api/data_set_join/' + this.client.url + "/validate", { join: join })
                    .then((response) => {
                        // Handle successful validation
                        if(response.data.orig > response.data.join) {
                            this.local_dataset.joins[joinIndex].message = '<h3>Warning!</h3><p>When joining this data set, the number of ' +
                                'records will drop from '+this.number_with_zero(response.data.orig)+
                                ' records to ' + this.number_with_zero(response.data.join)+'.</p>';
                        }
                        else if(response.data.orig < response.data.join) {
                            this.local_dataset.joins[joinIndex].message = '<h3>Warning!</h3><p>When joining this data set, the number of ' +
                                'records will increase from '+this.number_with_zero(response.data.orig)+
                                ' records to ' + this.number_with_zero(response.data.join)+'.</p>';
                        }
                        else
                            this.local_dataset.joins[joinIndex].message = null;

                        this.$forceUpdate();
                    });
            }
            this.outside_update = false;
        },
        isValid(show_errors = true) {
            // Reset all errors before validation
            this.errors = this.errors.map((joinError) => {
                return {
                    ...joinError,
                    joined_data_set: '',
                    name: '',
                    join_on: joinError.join_on.map(() => ({
                        source_column: '',
                        logic: [],
                        dest_column: '',
                        // Adding default_value_error to handle default value errors
                        default_value_error: ''
                    })),
                };
            });

            // Additional validation for join_on
            let hasErrors = false;
            for (let i = 0; i < this.local_dataset.joins.length; i++) {
                const join = this.local_dataset.joins[i];

                //Verify it has a name
                if(join.name == null || join.name == ''){
                    if(show_errors)
                        this.errors[i].name = 'Please give the join a short name for reference';
                    hasErrors = true;
                }
                //Verify name doesn't contain dots
                else if(join.name.includes('.')){
                    if(show_errors)
                        this.errors[i].name = 'Name cannot contain dots (.). Please use underscores (_) instead.';
                    hasErrors = true;
                }

                //Verify it has a joined data set
                if(!join.joined_data_set_id || join.joined_data_set_id <= 0){
                    if(show_errors) this.errors[i].joined_data_set = 'Please select a data set to join';
                    hasErrors = true;
                }

                const joinKeys = join.join_on;

                for (let j = 0; j < joinKeys.length; j++) {
                    const joinKey = joinKeys[j];

                    // Validate source_column
                    if (!joinKey.source_column.column) {
                        if(show_errors) this.errors[i].join_on[j].source_column = 'Please select a source column.';
                        hasErrors = true;
                    }

                    // If source_column is 'CUSTOM', perform additional validations
                    if (joinKey.source_column.column === 'CUSTOM') {
                        // Validate each unit's value and logic
                        if (
                            !joinKey.source_column.column_logic ||
                            !Array.isArray(joinKey.source_column.column_logic.units)
                        ) {
                            if(show_errors) this.errors[i].join_on[j].source_column = 'Custom logic is not properly configured.';
                            hasErrors = true;
                        } else {
                            joinKey.source_column.column_logic.units.forEach((unit, unitIndex) => {
                                // Initialize the error message if not already
                                if (!this.errors[i].join_on[j].logic[unitIndex]) {
                                    this.errors[i].join_on[j].logic[unitIndex] = '';
                                }

                                // Check if unit.value is set
                                if (!unit.value || unit.value.trim() === '') {
                                    if(show_errors) this.errors[i].join_on[j].logic[unitIndex] = 'Unit value is required.';
                                    hasErrors = true;
                                }

                                // Check if unit.logic is properly set
                                // Assuming unit.logic is an object or string that needs to be validated
                                // Modify the condition based on your actual logic structure
                                if (!unit.logic || Object.keys(unit.logic).length === 0) {
                                    if(show_errors) this.errors[i].join_on[j].logic[unitIndex] = 'Unit logic is required.';
                                    hasErrors = true;
                                }
                            });

                            // Validate default_value based on default_type
                            const defaultLogic = joinKey.source_column.column_logic;
                            if (!defaultLogic.default_type) {
                                if(show_errors) this.errors[i].join_on[j].default_value_error = 'Default type is required.';
                                hasErrors = true;
                            } else {
                                if (defaultLogic.default_type !== 'column') {
                                    if (!defaultLogic.default_value || defaultLogic.default_value.trim() === '') {
                                        if(show_errors) this.errors[i].join_on[j].default_value_error = 'Default value is required.';
                                        hasErrors = true;
                                    }
                                } else {
                                    if (!defaultLogic.default_value) {
                                        if(show_errors) this.errors[i].join_on[j].default_value_error = 'Default column value is required.';
                                        hasErrors = true;
                                    }
                                }
                            }
                        }
                    }

                    // Validate dest_column
                    if (!joinKey.dest_column.column) {
                        if(show_errors) this.errors[i].join_on[j].dest_column = 'Please select a destination column.';
                        hasErrors = true;
                    }

                    // Add more validations as needed
                }
            }

            if (hasErrors && show_errors) {
                this.$forceUpdate(); // Ensure the UI reflects the error messages
            }
            return !hasErrors;
        },
        getAvailableDatasetsToJoin(){
            var temp = [];
            [...this.all_datasets].forEach((ds) => {
                if (ds.id != this.local_dataset.id && ds.view_name && ds.view_name.trim() !== ''){
                    temp.push({
                        category: '',
                        text: ds.name,
                        value: ds.id.toString() // Ensure uniqueness
                    });
                }
            });
            // Check for duplicate values
            const seen = new Set();
            temp = temp.filter(item => {
                if (seen.has(item.value)) {
                    return false; // Remove duplicates
                }
                seen.add(item.value);
                return true;
            });

            this.available_datasets = temp;
        },
        getColumnsFromJoinedDataSet(dataset_selected){
            //Add the custom option to the start
            var custom_logic_option = {
                value: 'CUSTOM',
                text: 'Custom Logic',
                category: 'list-header'
            };
            var column_array = [];
            column_array.push(custom_logic_option);
            // transform the rest of columns 
            if(dataset_selected == undefined)
                return column_array;

            dataset_selected.columns.forEach((column) => {
                column.category = '';
                column.text = column.display_name;
                column.data_type = column.data_type;
                column.value = (column.destination_column == 'custom' ? 'custom.' + this.generateColumnName(column.display_name) : column.destination_column);
            });
            column_array = column_array.concat(dataset_selected.columns);
            return column_array;
        },
        generateColumnName(header) {
            // Trim spaces from both ends
            header = header.trim();

            // Replace one or more whitespace characters with an underscore
            header = header.replace(/\s+/g, '_');

            // Convert to lowercase
            header = header.toLowerCase();

            // Remove all non-alphanumeric characters except underscores
            header = header.replace(/[^a-z0-9_]/g, '');

            // Replace starting digit with corresponding word
            const digitToWord = {
                '0': 'zero',
                '1': 'one',
                '2': 'two',
                '3': 'three',
                '4': 'four',
                '5': 'five',
                '6': 'six',
                '7': 'seven',
                '8': 'eight',
                '9': 'nine'
            };

            const firstChar = header.charAt(0);
            if (digitToWord.hasOwnProperty(firstChar)) {
                header = digitToWord[firstChar] + header.slice(1);
            }

            // Limit the header to 120 characters
            if (header.length > 120) {
                header = header.substring(0, 120);
            }

            return header;
        },
        changeDatasetToJoin(index){
            let dataset_selected = this.all_datasets.find((dataset)=> dataset.id.toString() == this.local_dataset.joins[index].joined_data_set.value);
            
            dataset_selected.columns = this.getColumnsFromJoinedDataSet(dataset_selected);
            this.local_dataset.joins[index].joined_data_set = dataset_selected;      
            this.local_dataset.joins[index].joined_data_set_id = dataset_selected.id;
            
            if(this.local_dataset.joins[index].name == '') {
                let name = dataset_selected.name;
                // Sanitize name if dataset source is "Upload" - replace dots with underscores
                if (dataset_selected.source === "Upload") {
                    name = name.replace(/\./g, '_');
                }
                this.local_dataset.joins[index].name = name;
            }

            this.local_dataset.joins[index].join_on =[{
                id: Math.round(Math.random()*100000),
                source_column: {
                    editing: false,
                    column: null,
                    data_type: 'string'
                },
                dest_column: {
                    column: null
                },
            }];

            this.errors[index].name = '';
            for(let i = 0; i < this.local_dataset.joins.length; i++)
                this.local_dataset.joins[i].message = null;
            
            this.$emit('update:modelValue', this.local_dataset.joins);
            dataset_selected.message = null;
            this.$forceUpdate();
        },
        changeJoinType(index, join_type){
            this.local_dataset.joins[index].join_type = join_type;
            this.validateSettings();
            this.$emit('update:modelValue', this.local_dataset.joins);
            this.$forceUpdate();
        },
        addNewJoinData(){
            let temp = {
                id: Math.round(Math.random()*-10000), // get random negative number
                primary_data_set_id: this.local_dataset.id,
                joined_data_set_id: -1,
                joined_data_set: null,
                name: '',
                join_type: 'inner_join', // set to inner_join by default
                join_on: [{
                    id: Math.round(Math.random()*100000),
                    source_column: {
                        editing: false,
                        column: null,
                        data_type: 'string'
                    },
                    dest_column: {
                        column: null
                    },
                }]
            };
            this.open_accordion = temp.id;
            this.local_dataset.joins.push(temp);
            this.addEmptyError();
            this.$emit('update:modelValue', this.local_dataset.joins);
            this.$forceUpdate();
        },
        addEmptyError() {
            let error_temp = {
                joined_data_set: '',
                name: '',
                join_on: [this.getEmptyJoinError()]                    
            }
            this.errors.push(error_temp);
        },
        getEmptyJoinError() {
            return {
                source_column: '',
                logic: [],
                dest_column: ''
            };
        },
        addNewJoinKey(join_dataset_index){
            let temp = {
                id: Math.round(Math.random()*100000),
                source_column: {
                    editing: false,
                    column: null,
                    data_type: 'string'
                },
                dest_column: {
                    column: null
                },
            };
            this.local_dataset.joins[join_dataset_index].join_on.push(temp);
            let error_temp = this.getEmptyJoinError();                   
            this.errors[join_dataset_index].join_on.push(error_temp);
            this.$emit('update:modelValue', this.local_dataset.joins); 
            this.$forceUpdate();
        },
        deleteJoinDataKey(join_dataset_index, join_key_index){
            this.local_dataset.joins[join_dataset_index].join_on.splice(join_key_index, 1);
            this.errors[join_dataset_index].join_on.splice(join_key_index, 1);
            this.validateSettings();
            this.$emit('update:modelValue', this.local_dataset.joins);
            this.$forceUpdate();
        },
        deleteJoinData(index){
            Swal.fire({
              title: "Are you sure you want to delete this additional data?",
              text: "The data appended to the data set will be removed from options above and columns mapped will be removed. " + 
                (this.local_dataset.joins[index].id > 0 ? "This will result in the screen being refreshed." : ""),
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete",
              customClass: {
                popup: 'swal-warning'
              },
            }).then((result) => {
              if (result.isConfirmed) {
                //If it is in the database, delete it
                if(this.local_dataset.joins[index].id > 0) {
                    window.axios.delete('/api/data_set_join/'+this.client.url + '/' + 
                        this.local_dataset.joins[index].id).then((response) => {
                            //Refresh the screen to get it to reload everything
                            location.reload();
                        });
                }
                //Don't do this unless it isn't going to refresh
                if(this.local_dataset.joins[index].id < 0) {
                    this.local_dataset.joins.splice(index, 1);
                    this.errors.splice(index, 1);
                    this.$emit('update:modelValue', this.local_dataset.joins);
                    this.$forceUpdate();
                }
              }
            });
        },
        selectCustomLogic(join_dataset_index, join_key_index, join_key){
            this.errors[join_dataset_index].join_on[join_key_index].source_column = ''
            join_key.source_column.column = "CUSTOM";
            join_key.source_column.editing = true;
            join_key.source_column.column_logic = {
                default_type: "static",
                default_value: null,
                units: [this.getUnit()]
            };
            this.$forceUpdate();
        },
        getUnit() {
            return {
                id: Math.round(Math.random()*100000),
                value_type: 'static',
                value: '',
                logic: {
                    filter_logic: '1',
                    filter_option: 'custom',
                    filter_ui: 'simple',
                    logic_error_msg:null,
                    logic_units:[]
                }
            };
        },
        editing(join_dataset_index, join_key) {
            //Close all of the custom editors if they are open
            this.local_dataset.joins[join_dataset_index].join_on.forEach(join_key => {
                join_key.source_column.editing = false;
            });

            join_key.source_column.editing= true;
            this.$forceUpdate();
        },
        stopEditing(join_key) {
            join_key.source_column.editing = false;
            this.$forceUpdate();
        },
        onDragEnd(e) {
            //If they moved it...
            if(e.newIndex != e.oldIndex) {
                let show_pos = -1;

                //Get the ide of the currently open accordion item
                var open_item =document.querySelector('.accordion-collapse.show');
                if(open_item == null) return;

                var open = document.querySelector('.accordion-collapse.show')
                var open_pos = open.id.substring(open.id.indexOf('-')+1);
                var new_index = open_pos.substring(open_pos.indexOf('-')+1);

                //If the open one was the one that was moved

                if(parseInt(new_index) == e.oldIndex) {
                    show_pos = open_pos.substring(0, open_pos.indexOf('-')+1) + e.newIndex;
                }

                //If it needs to be toggled
                else if(parseInt(new_index) >= e.newIndex &&  parseInt(new_index) <= e.oldIndex || parseInt(new_index) <= e.newIndex &&  parseInt(new_index) >= e.oldIndex) {
                    show_pos = parseInt(new_index) + ((e.newIndex > e.oldIndex) ? -1 : 1);
                    show_pos = open_pos.substring(0, open_pos.indexOf('-')+1) + show_pos;
                }

                this.$nextTick(() => {
                    //Hide the open one
                    if (document.getElementById('collapse-' + open_pos)){
                        document.getElementById('collapse-' + open_pos).classList.remove('show');
                        document.querySelector('#heading-' + open_pos + ' .accordion-button').classList.add('collapsed');                                
                    }
                    //Show it without the annimations
                    if (document.getElementById('collapse-' + show_pos)){
                        document.getElementById('collapse-' + show_pos).classList.add('show');
                        document.querySelector('#heading-' + show_pos + ' .accordion-button').classList.remove('collapsed');
                    }
                });
            }
        },
        getPrettyColName(name) {
            if(name == null) return "(Not Set)";

            let split = name.split(".", 2);
            if(split.length > 1)
                return this.propercase(split[0].trim()) + ": " + this.propercase(split[1].trim());
            else
                return this.propercase(name);

        },
        removeLogicUnit(event, column, i) {
            column.source_column.column_logic.units.splice(i, 1);
            event.stopPropagation();
            this.$forceUpdate();
        },
        addLogicUnit(event, column, i) {
            var unit = this.getUnit();
            //Insert the unit in the column_logic object at the i position
            column.source_column.column_logic.units.splice(i+1, 0, unit );

            this.$nextTick(() => {
                //If there is one open, close it
                if(document.querySelector('.accordion-collapse.show') != null) {
                    var open = document.querySelector('.accordion-collapse.show')
                    var open_pos = open.id.substring(open.id.indexOf('-')+1);
                    if(document.getElementById('collapse-' + open_pos) != null) {
                        document.getElementById('collapse-' + open_pos).classList.remove('show');
                    }
                    if(document.querySelector('#heading-' + open_pos + ' .accordion-button') != null) {
                        document.querySelector('#heading-' + open_pos + ' .accordion-button').classList.add('collapsed');
                    }
                }
                const accordionElement = document.getElementById('collapse-' + column.id+'-' + (i+1));
                if (accordionElement) {
                    const bootstrapAccordion = new bootstrap.Collapse(accordionElement);
                    bootstrapAccordion.show();
                }
            });
            this.$forceUpdate();
        },
        getValueTypeDisplay(type) {
            if(type == 'sql')
                return 'SQL Value';
            if(type == 'column')
                return 'Column Value';

            return 'Static Value';
        },
        addColumnToText(id, valueToAdd) {
            var textField = document.getElementById('unit-text-' + id );

            // Get the cursor's position
            const startPos = textField.selectionStart;
            const endPos = textField.selectionEnd;

            // Get the current value of the text field
            const currentValue = textField.value;

            // Construct the new value with the added text
            const newValue =
            currentValue.substring(0, startPos) +
            valueToAdd +
            currentValue.substring(endPos);

            // Set the new value to the text field
            textField.value = newValue;

            // Move the cursor after the added text
            const newCursorPos = startPos + valueToAdd.length;
            textField.setSelectionRange(newCursorPos, newCursorPos);

            // Trigger any necessary events, e.g., input or change
            const inputEvent = new Event('input');
            textField.dispatchEvent(inputEvent);
        },
        sanitizeSQLStatement(join_dataset_index, join_key_index, j, unit) {
            //Only do this for SQL stuff
            if(unit.value_type != 'sql'){
                //Clear the errors
                if(unit.value.trim() != "" && this.errors[join_dataset_index].join_on[join_key_index].logic[j] != null){
                    this.errors[join_dataset_index].join_on[join_key_index].logic[j] = "";
                    this.$forceUpdate();
                }
                return;
            }

            // List of keywords to remove from the parameterValue
            const blacklistedKeywords = ['UPDATE', 'DROP', 'DELETE', 'INSERT', 'TRUNCATE'];

            // Remove blacklisted keywords
            let sanitizedValue = unit.value;
            blacklistedKeywords.forEach(keyword => {
                const regex = new RegExp(`\\b${keyword}\\b`, 'gi');
                sanitizedValue = sanitizedValue.replace(regex, '');
            });

            // Remove semicolons
            sanitizedValue = sanitizedValue.replace(/;/g, '');

            unit.value= sanitizedValue;
            //Clear the errors
            if(unit.value.trim() != "" && this.errors[join_dataset_index].join_on[join_key_index].logic[j] != null){
                this.errors[join_dataset_index].join_on[join_key_index].logic[j] = "";
                this.$forceUpdate();
            }
        },
        changeJoinKeyDefaultType(join_key, type){
            join_key.source_column.column_logic.default_type = type;
            this.$forceUpdate();
        },
        changeUnitValueType(unit, type){
            unit.value_type=type;
            this.$forceUpdate();
        }
    }
});
</script>